import createPersistedState from 'use-persisted-state'
import { User } from './types'
import { USER_STORAGE_KEY } from '../storage'

/**
 * The shared logged-in identity.
 *
 * `use-persisted-state` keyed `'user'` is the one channel every pilet already
 * reads from (favorites, the list toggles, the profile action) — its store lives
 * in module scope and is shared through the shell's importmap, so whatever the
 * shell writes here reaches every pilet in the same tab without a reload. The shell
 * is the single writer of truth: {@link AuthProvider} fills it from `whoami`.
 */
const useUserState = createPersistedState(USER_STORAGE_KEY)

export const useUser = () => useUserState<User | null>(null)
